import script from "./batch-qualifications-audit.vue?vue&type=script&lang=tsx&setup=true"
export * from "./batch-qualifications-audit.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__